import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/icon/money-circle-outline-blue.png'


const _hoisted_1 = { class: "master-new-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "border-bottom-white-darken-3 pb-3 flex items-center gap-4" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "X"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, /*#__PURE__*/_toDisplayString('Data Komisi Mandoran'))
  ])
], -1)
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-8" }
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "mb-2"
}, "Nama Komisi", -1)
const _hoisted_7 = { class: "border-bottom-white-darken-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "stationName",
  class: "mb-2"
}, "Terminal Asal", -1)
const _hoisted_9 = { class: "border-bottom-white-darken-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "className",
  class: "mb-2"
}, "Kelas", -1)
const _hoisted_11 = { class: "border-bottom-white-darken-3" }
const _hoisted_12 = { class: "flex flex-col gap-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "expenseTypeName",
  class: "mb-2"
}, "Jenis Pengeluaran", -1)
const _hoisted_14 = { class: "border-bottom-white-darken-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "mb-2"
}, "Deskripsi", -1)
const _hoisted_16 = { class: "border-bottom-white-darken-3" }
const _hoisted_17 = { class: "border border-gray-200 rounded-xl p-5 mt-5" }
const _hoisted_18 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-base text-gray-800" }, "Komisi Per RIT", -1)
const _hoisted_20 = { class: "pi pi-info-circle text-blue-500 cursor-pointer text-base" }
const _hoisted_21 = {
  key: 0,
  class: "background-blue-4 border border-blue-100 rounded-xl p-4 flex flex-col gap-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "commTypeOneTime",
  class: "font-semibold text-sm cursor-pointer text-gray-800"
}, "Jumlah Penumpang Dibawa", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Komisi untuk Mandoran sesuai jumlah penumpang yang dibawa.", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "background-blue-4 border border-blue-100 rounded-xl p-4 flex flex-col gap-3"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "commTypeOneTime",
  class: "font-semibold text-sm cursor-pointer text-gray-800"
}, "Mandoran Pertama", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Komisi untuk Mandoran pertama yang tap NFC ke Kondektur.", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm text-gray-800 block mb-1" }, "Komisi Mandoran Pertama (Rp)", -1)
const _hoisted_31 = { class: "w-72 mt-1" }
const _hoisted_32 = { class: "border-bottom-white-darken-3" }
const _hoisted_33 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_34 = { class: "overflow-x-auto rounded-lg border border-gray-200" }
const _hoisted_35 = { class: "w-full border-collapse" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-100 text-xs font-semibold text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-left w-16" }, "No."),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-left w-1/4" }, "Min. Jumlah Penumpang"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-left w-1/4" }, "Max. Jumlah Penumpang"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-left w-1/3" }, "Komisi (Rp)")
  ])
], -1)
const _hoisted_37 = { class: "divide-y divide-gray-200" }
const _hoisted_38 = { class: "py-3 px-4 text-sm text-gray-700 font-medium" }
const _hoisted_39 = { class: "py-3 px-4 text-sm text-gray-700 font-medium" }
const _hoisted_40 = { class: "py-3 px-4 text-sm text-gray-700 font-medium" }
const _hoisted_41 = { class: "py-3 px-4 text-sm text-gray-700 font-medium" }
const _hoisted_42 = { class: "border border-gray-200 rounded-xl p-5 mt-5" }
const _hoisted_43 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-base text-gray-800" }, "Komisi Per Penumpang", -1)
const _hoisted_45 = { class: "pi pi-info-circle text-blue-500 cursor-pointer text-base" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "font-semibold text-sm text-gray-800 block mb-1" }, "Komisi Mandoran Per Penumpang (Rp)", -1)
const _hoisted_47 = { class: "w-72 mt-1" }
const _hoisted_48 = { class: "border-bottom-white-darken-3" }
const _hoisted_49 = { class: "flex items-center gap-3 justify-end" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Kembali")

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import apiUseCase from '@/usecase/apiUseCase'
import numberFormat from '@/utils/helpers/numberFormat'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import Button from 'primevue/button'
import Card from 'primevue/card'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'ComissionDetail',
  setup(__props) {

const salesAgentCommissionEndpoint = 'management/v2/SalesAgentCommissions'
const store = useStore()
const route = useRoute()
const dataSource = ref(null) as any
const dataTierSource = ref([]) as any
const commissionId = ref(null) as any
const isTiered = ref(false)

const getCommissionTierData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${salesAgentCommissionEndpoint}/${commissionId.value}/Tiers`).then((response) => {
    const { error, result } = response
    if (!error) {
      dataTierSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getCommissionDetail = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${salesAgentCommissionEndpoint}/${commissionId.value}`).then((response) => {
    const { error, result } = response
    if (!error) {
      dataSource.value = result
      isTiered.value = result.CommissionType.toLowerCase() === 'tiered'
      if (isTiered.value) {
        getCommissionTierData()
      }
    }
  })
  store.dispatch('hideLoading')
}

const setBreadcrumb = () => {
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Komisi Mandoran',
      routeName: 'master-mandoran-commission'
    },
    {
      title: 'Detail Komisi',
      routeName: 'master-mandoran-commission-detail',
      params: { id: route.params.id }
    }
  ])
}

const closeTab = () => {
  window.close()
}

onMounted(async () => {
  commissionId.value = encryptDecriptMethods.decrypt(route.params.id)
  console.log('commisssionId', commissionId.value)
  await getCommissionDetail()
  setBreadcrumb()
})

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(dataSource)?.Name ?? '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(dataSource)?.StationName ?? '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(dataSource)?.ClassName ?? '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(dataSource)?.ExpenseTypeName ?? '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(dataSource)?.Description ?? '-'), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createElementVNode("i", _hoisted_20, null, 512), [
              [
                _directive_tooltip,
                'Komisi yang akan diterima Mandoran per 1 RIT.',
                void 0,
                { top: true }
              ]
            ])
          ]),
          _createElementVNode("div", null, [
            (isTiered.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
              : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
          ]),
          (!isTiered.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(rupiahFormat)(_unref(dataSource)?.PassengerCommissionAmount ?? 0)), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("table", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("tbody", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataTierSource), (dataTier, idx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: idx,
                          class: "hover:bg-gray-50/50"
                        }, [
                          _createElementVNode("td", _hoisted_38, _toDisplayString(_unref(numberFormat)(Number(idx) + 1)), 1),
                          _createElementVNode("td", _hoisted_39, _toDisplayString(_unref(numberFormat)(dataTier.MinPassengerCount ?? 0)), 1),
                          _createElementVNode("td", _hoisted_40, _toDisplayString(_unref(numberFormat)(dataTier.MaxPassengerCount ?? 0)), 1),
                          _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(rupiahFormat)(dataTier.CommissionAmount ?? 0)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _withDirectives(_createElementVNode("i", _hoisted_45, null, 512), [
              [
                _directive_tooltip,
                'Komisi yang akan diterima Mandoran per 1 penumpang.',
                void 0,
                { top: true }
              ]
            ])
          ]),
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(rupiahFormat)(_unref(dataSource)?.PassengerCommissionAmount ?? 0)), 1)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_unref(Button), {
            class: "btn-back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeTab()))
          }, {
            default: _withCtx(() => [
              _hoisted_50
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})